import React from 'react';

import { cn } from '../../lib/utils';

const IntegrationStatusBadge = ({ connected }) => {
  return (
    <span
      className={cn(
        'shrink-0 rounded-full px-2.5 py-1 text-[10px]/4 font-semibold',
        connected
          ? 'bg-green-100 text-green-700 dark:bg-green-950 dark:text-green-300'
          : 'bg-gray-100 text-gray-500 dark:bg-neutral-800 dark:text-neutral-400',
      )}
    >
      {connected ? 'Connected' : 'Not connected'}
    </span>
  );
};

export default IntegrationStatusBadge;
